// A full-width photo banner that separates the story from the calculators. The photos are free under the Unsplash
// License and load from Unsplash's image CDN, which sizes them per screen. If one fails to load, the forest green shows through
// and the text still reads.
interface Photo {
  /** The images.unsplash.com address, without size parameters. */
  src: string;
  by: string;
  profile: string;
  page: string;
  /** object-position, so the subject stays in frame as the banner crops. */
  focus: string;
}

const PHOTOS = {
  taxForms: {
    src: "https://images.unsplash.com/photo-1554224155-cfa08c2a758f",
    by: "Kelly Sikkema",
    profile: "https://unsplash.com/@kellysikkema",
    page: "https://unsplash.com/photos/tax-forms-and-coffee-on-desk-8DEDp6S93Po",
    focus: "60% 50%",
  },
  calculatorCharts: {
    src: "https://images.unsplash.com/photo-1768055104923-a6f76e7478c7",
    by: "Jakub Żerdzicki",
    profile: "https://unsplash.com/@jakubzerdzicki",
    page: "https://unsplash.com/photos/Jfm-icueJUU",
    focus: "50% 50%",
  },
} satisfies Record<string, Photo>;

/** The photo on the site. The backup is PHOTOS.calculatorCharts. */
const PHOTO: Photo = PHOTOS.taxForms;

const WIDTHS = [800, 1200, 1600, 2400];
const sized = (w: number) => `${PHOTO.src}?auto=format&fit=crop&q=70&w=${w}`;

export function Banner() {
  return (
    <section className="banner" aria-label="Futures Tax Report" data-reveal>
      <img
        className="banner-photo"
        src={sized(1600)}
        srcSet={WIDTHS.map((w) => `${sized(w)} ${w}w`).join(", ")}
        sizes="100vw"
        alt=""
        loading="lazy"
        decoding="async"
        referrerPolicy="no-referrer"
        style={{ objectPosition: PHOTO.focus }}
      />
      <div className="banner-shade" aria-hidden="true" />
      <div className="shell banner-copy">
        <p className="eyebrow">Futures · Prop payouts · Section 1256</p>
        <p className="banner-title">
          You trade the market. <em>We show you the math.</em>
        </p>
      </div>
      <p className="banner-credit">
        Photo: <a href={PHOTO.profile} target="_blank" rel="noopener noreferrer">{PHOTO.by}</a> on <a href={PHOTO.page} target="_blank" rel="noopener noreferrer">Unsplash</a>
      </p>
    </section>
  );
}
